import React, { useEffect, useRef, useState} from "react";
import Loading, { UploadLoading } from "components/Loading";
import {
    NoLinePrimaryBtn,
    OutlinePrimaryBtn,
    SolidPrimaryBtn,
    SolidPrimarySubBtn,
    SolidRedBtn
} from "components/button/Button";
import {EllipsisTextColumn, FlexGrow, ListContentWrap, PageArticleWrap, PageHeaderTitleButtonStyle} from "components/layout/Layout";
import {CustomCheckbox, selectOption, SelectOption} from "components/input/Input";
import {NoDataWithImageText} from "components/NoDataComponent";
import styled from "styled-components";
import {
    ClassInfo,
    ClassQueryParams,
    ExcelStudentInfo,
    ListResult, provinceInfo, SingleResult,
    StudentInfo,
    StudentParentType,
    StudentQueryParams, StudentRequestType, UserInfo,
    UserQueryParams
} from "../../type/type";
import {
    createStudentExcelHandler,
    createStudentHandler, ExcelFormType,
    excelFormDownload,
    getImageUrl,
    getStudent,
    getUser,
    removeStudentHandler,
    updateStudentHandler,
    removeStudentAllHandler,
    getClass
} from "../../api/api";
import {
    aesCBCDecrypt,
    aesCBCEncrypt, changeRelationWithStudentType, checkFutureDate, checkKoreanWord,
    checkMobile,
    checkName,
    ellipsisText,
    formatDateToKorean,
    formattedBirthDay,
    formattedSelectOptionNamePhone,
    formattedSelectOptionNotAll,
    getStudentImageUrl,
    handleImageUpload,
    isValidDate,
    maskedPhoneNumber,
    NoStudentDataText,
    NoTeamClassDataText,
    relationWithStudent,
    ROLE_DIRECTOR,
    ROLE_PARENT,
    ROLE_TEACHER,
    userClassSelectOption
} from "../../utils/commonUtils";
import {RoundBigImage, RoundImageContainer} from "components/common/Image";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import PlusIcon from "../../assets/image/common/plus.png";
import { FlexWrapC, FlexWrapR, InputWrapC, InputWrapR } from "components/common/CommonLayout";
import * as XLSX from "xlsx";
import { useRecoilValue } from "recoil";
import { selectSiteIdState, userRoleState } from "styles/atoms";
import { useLoginUserInfo } from "../../redux/hook/useLoginUserInfo";

const TableColumn = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    
    > div {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem 0.75rem;
        &.col {
            flex-direction: column;
            gap: 0.25rem;
        }
    }

    .thumbnail-wrap {
        max-height: 5rem;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    &:hover {
        background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
    }
`;

//left content
const RowContentLeftWrap = styled.div`
    width: 25%;
    .file-wrap {
        padding-right: 2rem;
        width: 100%;
    }
`;

const ImageOneWrap = styled.div`
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .preview-image {
        height: 100%;
        width:100%;
        border-radius: 50%;
    } 
    .carema-icon {
        position: absolute;
        top: 75%;
        left: 70%;
    }  
    .delete-preview-image {
        display: none;
        position: absolute;
        top: 1px;
        right: 1px;
    }
    &:hover {
        cursor: pointer;

        img:not(.cancel-icon),
        label {
            opacity: 0.7;
        }
        .delete-preview-image {
            display: block;
        }
    }
`;

//right content
const MiddleContentWrap = styled.div`
    border-top: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    
    p {
        padding: 1rem 0;
        font-weight: 600;
    }
    
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 1rem;
        padding: 0.5rem 1.25rem;

        img {
            width: 1rem;
            aspect-ratio: 1 / 1;
        }
    }
`
const NoDataWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const UploadingComponent = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
`;

interface StudentListViewerProps {
    studentList: StudentInfo[]; //학생 목록
    parentList: UserInfo[]; //학부모 목록
    allStudentCheck: boolean; //모든 학생 체크 여부
    studentCheckIdList: number[]; //체크된 학생 ID 목록
    setAllStudentCheck: (value:boolean) => void; //모든 학생 체크 여부 변경
    handleAllStudentCheck: () => void; //모든 학생 체크 선택
    handleStudentCheck: (studentId: number) => void; //학생 체크 선택
    changeRequestStudent: (studentId:number,studentInfo:StudentInfo) => void; //학생 수정 정보 변경
    openModal:(modalType:ModalType) => void; //모달 오픈
}


/**
 * 학생 목록 출력
 * @param studentList
 * @param parentList
 * @param allStudentCheck
 * @param studentCheckIdList
 * @param setAllStudentCheck
 * @param handleAllStudentCheck
 * @param handleStudentCheck
 * @param changeRequestStudent
 * @param openModal
 * @constructor
 */
const StudentListViewer:React.FC<StudentListViewerProps> = ({studentList,
                                                            parentList,
                                                            allStudentCheck,
                                                            studentCheckIdList,
                                                            setAllStudentCheck,
                                                            handleAllStudentCheck,
                                                            handleStudentCheck,
                                                            changeRequestStudent,
                                                            openModal}) => {
                                                            
    useEffect(() => {
        if(studentList.length > 0 && studentCheckIdList.length === studentList.length){
            setAllStudentCheck(true);
        }else{
            setAllStudentCheck(false);
        }

    }, [studentCheckIdList, studentList, setAllStudentCheck]);

    return (
        <ListContentWrap style={{ height: 'calc(100% - 3rem)'}}>
            <div className="list-one-wrap h100">
                <div className="list-table">
                    <div>
                        <nav className="list-table-header">
                            <FlexWrapR $alignItems="center" $justifyContent="center" $gap="0" className="w-5">
                                <CustomCheckbox type="checkbox"
                                                checked={allStudentCheck}
                                                onClick={handleAllStudentCheck}/>
                            </FlexWrapR>
                            <div className="w-10">사진</div>
                            <FlexGrow className="w-12">이름</FlexGrow>
                            <FlexGrow className="w-12">반</FlexGrow>
                            <div className="w-15">생년월일</div>
                            <FlexGrow className="w-15">학부모</FlexGrow>
                            <FlexGrow className="w-12">연락처</FlexGrow>
                            <FlexGrow className="w-12">긴급 연락처</FlexGrow>
                            <div className="w-8"></div>
                        </nav>
                {/*{학생 출력}*/}
                {studentList.map((student, index) => {
                    const className = student.class_list.length > 0 ? student.class_list[0].name : "";
                    const birthDate = student.birth_date ? formatDateToKorean(student.birth_date) : "";
                    const tempGuardianPhone = student.temp_guardian_phone ? aesCBCDecrypt(student.temp_guardian_phone) : "";
                    return (
                        <TableColumn>
                            <div className="w-5">
                                <CustomCheckbox type="checkbox"
                                                value={student.id}
                                                checked={studentCheckIdList.includes(student.id)}
                                                onClick={() => {
                                                    handleStudentCheck(student.id)
                                                }}/>

                            </div>
                            <RoundImageContainer className="w-10">
                                <RoundBigImage src={student.image_url} alt="profile"/>
                            </RoundImageContainer>
                            <FlexGrow className="w-12">
                                <EllipsisTextColumn>{aesCBCDecrypt(student.name)}</EllipsisTextColumn>
                            </FlexGrow>
                            <FlexGrow className="w-12">
                                <EllipsisTextColumn>{className}</EllipsisTextColumn>
                            </FlexGrow>
                            <div className="w-15">{birthDate}</div>
                            <FlexGrow className="w-15 col">
                                {student.parent_list.map(p => 
                                    <EllipsisTextColumn>{ellipsisText(aesCBCDecrypt(p.user_name), 6) || ""}{p.relation && `(${ellipsisText(p.relation, 5)})`}</EllipsisTextColumn>
                                )}
                            </FlexGrow>
                            <FlexGrow className="w-12 col">
                                {student.parent_list.map(p => {
                                    const parentId = p.user_id || 0;
                                    let parentPhone = "";
                                    if (parentId) {
                                        const parent = parentList.find((p: UserInfo) => p.id === parentId);
                                        parentPhone = parent ? aesCBCDecrypt(parent.phone) : "";
                                    }
                                    return (
                                        <EllipsisTextColumn>{parentPhone}</EllipsisTextColumn>
                                    )
                                })}
                            </FlexGrow>
                            <FlexGrow className="w-12">
                                <EllipsisTextColumn>{tempGuardianPhone}</EllipsisTextColumn>
                            </FlexGrow>
                            <div className="w-8">
                                <OutlinePrimaryBtn type="button"
                                                className="little-btn"
                                                onClick={() => {
                                                    openModal('updateStudent');
                                                    changeRequestStudent(student.id, student);
                                                }}>
                                    수정
                                </OutlinePrimaryBtn>
                            </div>
                        </TableColumn>
                    );
                })}
                    </div>
                </div>
            </div>
        </ListContentWrap>
    )
};


export const StudentManagement = () => {
    
    // 전역 데이터
    const user_role = useRecoilValue(userRoleState);
    const selectSiteId = useRecoilValue(selectSiteIdState);

    const { access } = useLoginUserInfo();
    const { user_id } = access;

    const [classList, setClassList] = useState<ClassInfo[]>([]);
    const [classId, setClassId] = useState(0);
    const [classSelectOption, setClassSelectOption] = useState<provinceInfo[]>([]);
    
    const [loading, setLoading] = useState<boolean>(true);
    const imageInput = useRef<HTMLInputElement>(null);

    //학생 목록
    const [studentList, setStudentList] = useState<StudentInfo[]>([]);
    //클릭 된 학생 ID
    const [clickStudentId, setClickStudentId] = useState<number>(0);
    //학생 목록 조회 파라미터
    const [studentQueryParams, setStudentQueryParams] = useState<StudentQueryParams>({
        page: 1,
        size: 1000,
        user_id: 0, // 학부모 ID
        name: "", //학생 이름 검색어
        class_id: classId, //반 ID
    })
    
    const [excelSelectClassId, setExcelSelectClassId] = useState<number>(0);
    
    //모달 display용 이미지 url
    const [selectImageUrl, setSelectImageUrl] = useState<string>("");

    /**
     * base64_list -> 서버 request 요청시 사용
     * image_url -> display용
     */
    const defaultRequestStudent:StudentRequestType = {
        site_id: selectSiteId,
        name:"",
        gender:1,
        birth_date:"",
        unique_code:"",
        card_no:"",
        temp_guardian_name:"",
        temp_guardian_phone:"",
        temp_guardian_relation:"",
        parent_list:[{
            user_id: 0,
            relation: "",
        }],
        base64_list:[],
        class_id: 0,
    }

    const [requestStudent, setRequestStudent] = useState<StudentRequestType>(defaultRequestStudent);

    // [학부모] - 학생과의 관계 옵션
    const [parentRelationSelectOptions, setParentRelationSelectOptions] = useState<selectOption[]>([]);
    // [학부모] - 학생과의 관계 직접 입력 선택 시 input toggle
    const [isRelationEtc, setIsRelationEtc] = useState<Boolean[]>([]);
    // [학부모] - 학생과의 관계 직접 입력 시 입력한 내용(api보낼 때 relation과 바꾸기)
    const [relationEtcText, setRelationEtcText] = useState<string[]>([]);

    // [긴급연락처] - 학생과의 관계 옵션
    const [guardianRelationSelectOptions, setGuardianRelationSelectOptions] = useState<selectOption[]>([]);
    // [긴급연락처] - 학생과의 관계 직접 입력 선택 시 input toggle
    const [isGuardianRelationEtc, setIsGuardianRelationEtc] = useState(false);
    // [긴급연락처] - 학생과의 관계 직접 입력 시 직접 입력한 내용(api보낼 때 relation과 바꾸기)
    const [guardianRelationEtcText, setGuardianRelationEtcText] = useState("");
    

    //모달 오픈 시 requestStudent 초기화
    const initRequestStudent = () => {
        // 초기화
        setIsRelationEtc([false]);
        setRelationEtcText([""]);
        setIsGuardianRelationEtc(false);
        setGuardianRelationEtcText("");

        setSelectImageUrl("");
        // 학생과의 관계 옵션 설정
        const relationList = formattedSelectOptionNotAll(relationWithStudent.map((r) => ({ label: r.label, value: r.value })));
        setParentRelationSelectOptions(relationList);
        setGuardianRelationSelectOptions(relationList);

        if(user_role === ROLE_TEACHER)
            setRequestStudent({...defaultRequestStudent, class_id: classId});
        else
            setRequestStudent(defaultRequestStudent);
    }

    //수정 하기 클릭시 해당 학생 정보를 requestStudent에 저장
    const changeRequestStudent = (studentId: number, studentInfo: StudentInfo) => {
        // 초기화
        setIsRelationEtc([]);
        setRelationEtcText([]);
        setIsGuardianRelationEtc(false);
        setGuardianRelationEtcText("");


        setClickStudentId(studentId);
        //이미지 url 저장
        setSelectImageUrl((studentInfo.image_list.length > 0 && studentInfo.image_list[0].file_size) ? getImageUrl(studentInfo.image_list[0].file_name) : "");
        
        setRequestStudent({
            site_id: selectSiteId,
            name:aesCBCDecrypt(studentInfo.name), //요청하기전에 암호화하기 때문에
            gender:studentInfo.gender,
            birth_date:studentInfo.birth_date,
            unique_code:studentInfo.unique_code,
            card_no:studentInfo.card_no,
            temp_guardian_name:aesCBCDecrypt(studentInfo.temp_guardian_name),
            temp_guardian_phone:aesCBCDecrypt(studentInfo.temp_guardian_phone),
            temp_guardian_relation:studentInfo.temp_guardian_relation,
            parent_list:studentInfo.parent_list.length ? studentInfo.parent_list.map((parent) => {
                return {
                    user_id:parent.user_id,
                    relation:parent.relation,
                }
            }) : [{user_id: 0, relation: ""}],
            base64_list:[],
            class_id:studentInfo.class_list[0] ? studentInfo.class_list[0].id : 0,
        });

        // 학생과의 관계 옵션 설정
        const relationList = formattedSelectOptionNotAll(relationWithStudent.map((r) => ({ label: r.label, value: r.value })));
        setParentRelationSelectOptions(relationList);
        setGuardianRelationSelectOptions(relationList);

        // [학부모] - 직접 입력한 경우
        const parentRelation =  studentInfo.parent_list.map((p: StudentParentType) => {
            const isDirectInput = changeRelationWithStudentType(p.relation) === 7;
            setRelationEtcText(prev => [...prev, p.relation]);
            return isDirectInput;
        });
        setIsRelationEtc(parentRelation);
        

        // [긴급연락처] - 직접 입력한 경우
        const checkGuardianType = changeRelationWithStudentType(studentInfo.temp_guardian_relation) === 7;
        setIsGuardianRelationEtc(checkGuardianType);
        setGuardianRelationEtcText(studentInfo.temp_guardian_relation);
    }

    //모달 상태
    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    const openModal = (modalType:ModalType)=> {
        let title:ModalTitle = "";
        let content:JSX.Element = <></>;
        let button:JSX.Element = <></>;
        switch (modalType){
            case "createStudent":
                title = "학생 신규 등록";
                break;
            case "updateStudent":
                title = "학생 정보 수정";
                break;
            case "excelCreateAllStudent":
                title = "엑셀 파일로 학생 일괄 등록";
                break;
        }
        setModalProps({
            isOpen:true,
            isClose:() => {
                setModalProps({...modalProps, isOpen:false});
            },
            title:title,
            content:content,
            button:button,
            type:modalType
        });
    }

    //학부모 선택 옵션
    const [parentList, setParentList] = useState<UserInfo[]>([]);
    const [parentSelectOptions, setParentSelectOptions] = useState<selectOption[]>([]);

    //모든 학생 체크 박스 선택
    const [allStudentCheck, setAllStudentCheck] = useState<boolean>(false);

    //목록 학생 체크 박스 선택
    const [studentCheckIdList, setStudentCheckIdList] = useState<number[]>([]);

    //모든 학생 체크 이벤트
    const handleAllStudentCheck = ():void => {
        if(studentCheckIdList.length === studentList.length){
            setStudentCheckIdList([]);
        }
        else{
            const studentIdList = studentList.map((student) => student.id);
            setStudentCheckIdList(studentIdList);
        }
    }

    //개별 학생 체크 이벤트
    const handleStudentCheck = (studentId: number):void => {
       if(studentCheckIdList.includes(studentId)){
           setStudentCheckIdList(studentCheckIdList.filter(checkId => checkId !== studentId));
       }
       else {
          setStudentCheckIdList([...studentCheckIdList, studentId]);
       }
    }

    //학생 목록 조회 파라미터 변경
    function changeStudentQueryParams(updates: Partial<StudentQueryParams>) {
        setStudentQueryParams((prev) => {
            return {...prev, ...updates}
        });
    }

    //반 select 옵션 변경
    function handleClassSelectOptions(class_id: number) {
        changeStudentQueryParams({class_id:class_id});
    }

    //학부모 select 옵션 변경
    // function handleParentSelectOptions(user_id:number){
    //     changeStudentQueryParams({
    //         user_id:user_id
    //     });
    // }

    //학생 select 옵션 변경
    // function handleStudentSelectOptions(user_id:number){
    //     changeStudentQueryParams({
    //         user_id:user_id
    //     });
    // }

    //학생 select 옵션 변경
    function handleStudentNameSearch(name:string){

        if(!name){
            changeStudentQueryParams({
                name:""
            });
            return;
        }
        //학생 이름 암호화
        changeStudentQueryParams({name:aesCBCEncrypt(name)});
    }

    //엑셀 파일
    const [excelFile, setExcelFile] = useState<File | null>(null);
    //이미지 파일
    const [imageFiles, setImageFiles] = useState<FileList | null>(null);
    const [excelStudentList, setExcelStudentList] = useState<ExcelStudentInfo[]>([]);

    // 엑셀 파일로 일괄 등록 모달 클릭 시 초기화
    const initExcel = () => {
        setExcelSelectClassId(0);
        setExcelStudentList([]);
        setExcelFile(null);
        setImageFiles(null);
    }

    //엑셀 파일 업로드 함수
    const handleExcelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        try{

            const file = e.target.files ? e.target.files[0] : null;
            if(!file){
                //excel 학생 초기화
                setExcelStudentList([]);
                setExcelFile(null);
            }
            //엑셀 파일 저장
            setExcelFile(file);
            //엑셀 파일 읽기
            if (file) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const data = event.target?.result;
                    if (data) {
                        const workbook = XLSX.read(data, { type: 'binary' });

                        //첫번째 시트 이름
                        const firstSheetName = workbook.SheetNames[0];

                        //첫번째 시트 데이터
                        const worksheet = workbook.Sheets[firstSheetName];

                        //첫번째 시트의 총 데이터
                        const objectData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        if(objectData.length === 0){
                            alert("엑셀 파일에 학생 정보가 없습니다.");
                            return;
                        }

                        //허용되는 헤더 필드
                        //const allowedHeaderList = ["이름","성별 (남자,여자)","생년월일 (YYYYMMDD)"];
                        const allowedHeaderList = ["이름","생년월일 (YYYYMMDD)"];
                        //첫번째 row의 인덱스 위치를 저장하기 위한 map
                        const headerIndexMap = new Map<string, number>();
                        //첫번째 row는 학생 정보가 아닌 엑셀의 컬럼명
                        const excelFirstRows:any = objectData[0];

                        //헤더 필드의 위치를 저장
                        if(excelFirstRows && typeof excelFirstRows === "object"){
                            //row의 column을 순회하면서 헤더 필드가 존재하는지 확인
                            for(let i=0; i < excelFirstRows.length; i++){

                                if(excelFirstRows[i].includes("이름")){
                                    headerIndexMap.set(allowedHeaderList[0],i);
                                }
                                // else if(excelFirstRows[i].includes("성별")){
                                //     headerIndexMap.set(allowedHeaderList[1],i);
                                // }
                                else if(excelFirstRows[i].includes("생년월일")){
                                    headerIndexMap.set(allowedHeaderList[1],i);
                                }
                            }
                        }
                        
                        //헤더 필드가 2개 모두 존재하지 않을 경우
                        if(headerIndexMap.size !== 2){
                            alert("학생 정보가 아닌 엑셀 파일입니다.");
                            return;
                        }

                        //첫번째 row는 제거
                        objectData.shift();

                        // Excel 학생 정보
                        const getExcelStudentList: any[] = objectData.map((data: any) => {
                            const nameIndex = headerIndexMap.get(allowedHeaderList[0]);
                            //const genderIndex = headerIndexMap.get(allowedHeaderList[1]);
                            const birthDateIndex = headerIndexMap.get(allowedHeaderList[1]);

                            // 인덱스가 올바르게 존재하는지 확인
                            if (nameIndex === undefined || birthDateIndex === undefined) {
                                console.error("헤더 인덱스를 찾을 수 없습니다.");
                                return null;
                            }
                            
                            // 이름을 입력 안한 경우 제외
                            if (!data[nameIndex]) return null;

                            // type check - 사용자가 엑셀에 기본으로 되어있는 텍스트를 일반 또는 다른 형식(날짜)로 바꾸는 경우가 있음
                            const birthDateData = data[birthDateIndex];
                            let birthDateValue: string = birthDateData ? (typeof birthDateData === 'string' ? birthDateData : birthDateData.toString()) : "";

                            // '-' 추가(yyyy-MM-dd)
                            if (birthDateValue) {
                                birthDateValue = birthDateValue.replace(/\D/g, '');

                                if (birthDateValue.length === 8) {
                                    birthDateValue = birthDateValue.slice(0, 4) + '-' + birthDateValue.slice(4, 6) + '-' + birthDateValue.slice(6);
                                }
                                else birthDateValue = "";

                                // 유효한 날짜인지 확인, 유효한 날짜인데 미래인지 확인
                                birthDateValue = isValidDate(birthDateValue) ? (checkFutureDate(birthDateValue) !== 'P' ? "": birthDateValue) : "";
                            }

                            return {
                                name: data[nameIndex].trim(),
                                birthDate: birthDateValue,
                            };
                        }).filter((excelStudent) => excelStudent !== null); // null 값은 필터링하여 제외

                        setExcelStudentList(getExcelStudentList);
                    }
                };
                // 파일 업로드가 끝나고 초기화해야 동일한 파일 이름으로 재업로드 가능
                reader.onloadend = () => {
                    e.target.value = "";
                };

                reader.readAsBinaryString(file);
            }

        }
        catch(e){
            console.error(e);
        }
    };

    //이미지 파일 업로드 함수
    const handleImagesChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        try{
            if(!excelFile){
                alert("엑셀 파일을 먼저 업로드 해주세요.");
                return
            }

            const imageFiles:any = e.target.files;
            if(!imageFiles){
                return;
            }

            // usestate는 비동기로 작동되어서, 누적된 데이터를 저장하기 위해
            let updatedExcelStudentList = [...excelStudentList];
            //이미지 파일 origin 이름으로 학생 이름과 매칭
            for (const imageFile of imageFiles) {
                //확장자 추출
                const extension = imageFile.name.split('.').pop();
                //확장자 제거된 파일 이름
                let fileName = imageFile.name.replace(`.${extension}`, "").trim();
                //완성형 한글로 변경
                if(!checkKoreanWord(fileName)){
                    //조합형 으로 변경
                    fileName = fileName.normalize('NFC'); // NFC로 정규화
                }

                //학생 이름과 매칭
                const findExcelStudent = excelStudentList.find((excelStudent) => {
                    return excelStudent.name === fileName
                });


                if(findExcelStudent){
                    // 매칭된 학생의 이미지 파일 업데이트
                    updatedExcelStudentList = updatedExcelStudentList.map((excelStudent: ExcelStudentInfo) => {
                        if (excelStudent.name === fileName) {
                            return {
                                ...excelStudent,
                                imageFile: imageFile,
                            };
                        }
                        return excelStudent;
                    });
                }
            }

            //누적된 데이터를 excelStudentList에 저장
            setExcelStudentList(updatedExcelStudentList);
            setImageFiles(imageFiles);
        }
        catch(e){
            console.error(e);
        }
    };

    //폼 양식 다운로드 link 생성
    const createElementLinkForDownload = async  (excelFormType:ExcelFormType) => {
        try{
            const result  = await excelFormDownload(excelFormType);
            const url = window.URL.createObjectURL(result);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "aischool_students_form.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        catch(e){
            console.error(e);
        }
    }

    /**
     * 엑셀 파일 업로드 모달 컨텐츠
     */
    const ExcelCreateAllStudentContent = (): JSX.Element => {
        
        //클래스 선택 옵션 깊은 복사
        let classSelectOptionsCopy = JSON.parse(JSON.stringify(classSelectOption));
        if (user_role === ROLE_DIRECTOR) {
            if(classSelectOptionsCopy.length)
                classSelectOptionsCopy = classSelectOptionsCopy.filter((_: any, i: number) => i !== 0);
        }


        function handleExcelClassIdChange(classId: number) {
            setExcelSelectClassId(classId);
        }

        return (
            <FlexWrapC $gap="1rem">
                <div>
                    {/*엑셀 폼 양식 다운로드*/}
                    <SolidPrimarySubBtn onClick={() => {createElementLinkForDownload(ExcelFormType.CREATE_ALL_STUDENT)}}>
                        폼 양식 다운로드
                    </SolidPrimarySubBtn>
                </div>

                <InputWrapC>
                    <label className="required_value">1. 반 선택</label>
                    {
                        user_role === ROLE_DIRECTOR ?
                        <SelectOption optionData={classSelectOptionsCopy} defaultValue={excelSelectClassId} onChange={(classId:number) => {handleExcelClassIdChange(classId)}}/>
                        :
                        <SelectOption 
                            optionData={classSelectOptionsCopy}
                            defaultValue={Number(classSelectOptionsCopy[0]?.value)}
                            dontChange 
                            onChange={(classId: number) => { handleExcelClassIdChange(classId) }} />
                    }
                </InputWrapC>

                <InputWrapC>
                    <label className="required_value">2. 엑셀 파일 업로드</label>
                    <input type="file" name="docs_file" accept=".xlsx, .xls, .csv"
                            onChange={handleExcelChange}/>
                </InputWrapC>

                <InputWrapC>
                    <label>3. 사진 업로드 (사진 파일명은 학생 이름으로 변경하여야 합니다.)</label>
                    <input type="file" name="image_files" accept=".jpg, .png, .jpeg" multiple
                            onChange={handleImagesChange}/>
                </InputWrapC>
                
                <label>4. 등록될 학생 목록({excelStudentList.length})</label>
                {/* 엑셀 학생 정보 */}
                {
                    excelStudentList.length > 0 &&
                    <ListContentWrap style={{gap: '0.5rem', height: 'calc(100% - 1.25rem - 0.5rem)'}}>
                        <div className="list-one-wrap h100">
                            <div className="list-table">
                                <div>
                                    <nav className="list-table-header">
                                        <div className="w-12">사진</div>
                                        <FlexGrow className="w-12">이름</FlexGrow>
                                        <FlexGrow className="w-12">생년월일</FlexGrow>
                                    </nav>
                                    {excelStudentList.map((excelStudent: ExcelStudentInfo, index) => {
                                        //이미지 파일이 있을 경우
                                        const imageUrl = excelStudent.imageFile ? URL.createObjectURL(excelStudent.imageFile) : DefaultProfileS;
                                        return (
                                            <TableColumn>
                                                <RoundImageContainer className="w-12">
                                                    <RoundBigImage src={imageUrl} alt="profile"/>
                                                </RoundImageContainer>
                                                <FlexGrow className="w-12">
                                                    <EllipsisTextColumn>{excelStudent.name}</EllipsisTextColumn>
                                                </FlexGrow>
                                                <FlexGrow className="w-12">
                                                    <EllipsisTextColumn>{excelStudent.birthDate}</EllipsisTextColumn>
                                                </FlexGrow>
                                            </TableColumn>

                                        )
                                    })}
                                </div>
                                {isUpload && <UploadingComponent><UploadLoading /></UploadingComponent> }
                            </div>
                        </div>
                    </ListContentWrap>
                }

            </FlexWrapC>
        );
    }
    
    const [isUpload, setIsUpload] = useState(false);
    const ExcelModalButton = ():JSX.Element => {

        //서버에 엑셀,이미지파일 업로드 요청
        const uploadFilesHandler = async () => {
            // 검증
            if(!excelFile){
                alert("엑셀 파일을 선택해주세요.");
                return;
            }

            const formData = new FormData();
            formData.append("docs_file", excelFile as Blob); //엑셀파일
            if(imageFiles){ //이미지파일
                for(let i=0; i<imageFiles.length; i++){
                    formData.append("image_files", imageFiles[i]);
                }
            }

            if(excelSelectClassId === 0){
                alert("등록될 반을 선택해주세요.");
                return;
            }

            try {
                
                setIsUpload(true);
                // API 전송
                const res:SingleResult<StudentInfo[]> = await createStudentExcelHandler(formData, excelSelectClassId);
                if (res.code === 200) {
                    alert("학생이 일괄 등록되었습니다.");
                    setModalProps({ ...modalProps, isOpen: false });
                    getClassList();

                }
                else{
                    alert("학생 일괄 등록에 실패했습니다, 다시 시도해주세요.");
                }
            }
            catch (e){
                console.error(e);
                alert("학생 일괄 등록에 실패했습니다, 다시 시도해주세요.");
            }
            finally {
                //엑셀 학생 초기화
                setExcelStudentList([]);
                setExcelFile(null);
                setImageFiles(null);
                setExcelSelectClassId(classId);
                setIsUpload(false);
            }
        }

        return (
            <SolidPrimaryBtn onClick={uploadFilesHandler}>
                일괄 등록
            </SolidPrimaryBtn>
        )
    }

    /**
     * 학생 모달 컨텐츠
     */
    const StudentModalContent = (): JSX.Element => {

        //학생 등록 정보 업데이트
        function updateRequestStudent(updates: Partial<StudentRequestType>){
            setRequestStudent({
                ...requestStudent,
                ...updates
            })
        }

        // 파일 선택 - input 클릭 시(사진)
        const handleImageFileClick = (e: any) => {
            imageInput.current?.click();
        };

        const setBase64Image = (base64: string) => {
            //이미지는 1개만 등록할수 있게, 배열 초기화 후 추가
            setRequestStudent({
                ...requestStudent,
                base64_list: [...[], base64],
            });

            //display용 이미지 url 저장
            setSelectImageUrl(base64);
        };

        //이미지 파일 변경 이벤트
        const onImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
            const base64Files:string[]|undefined = await handleImageUpload(event);
            if (base64Files && base64Files.length > 0) {
                setBase64Image(base64Files[0]);
            }
        };

        //input 값 변경 이벤트
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            updateRequestStudent({ [name]: value }); // 상태 업데이트
        };

        //생년월일 값 변경 이벤트
        const handleBirthDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {

            const birth = formattedBirthDay(e.target.value);

            updateRequestStudent({ birth_date: birth }); // 상태 업데이트
        };

        //클래스 select 값 변경 이벤트
        const handleClassChangeSelect = (value:number) => {
            updateRequestStudent({class_id:value});
        }

        // updateRequestStudent 전 parent_list update
        const updateParentList = (index: number, updateData: Partial<StudentParentType>) => {
            const selectIndexParent: StudentParentType[] = [...requestStudent.parent_list];
            const updatedParentList = selectIndexParent.map((p:StudentParentType, idx: number) => {
                return index === idx ? { ...p, ...updateData } : p;
            });

            updateRequestStudent({ parent_list: updatedParentList });
        };
        
        //[학부모] - 학부모 선택 select 값 변경 이벤트
        const handleParentChangeSelect = (value: number, index: number) => {

            // 학생과의 관계 초기화
            setIsRelationEtc((prev) => {
                const newData = [...prev];
                newData[index] = false;
                return newData;
            });
            setRelationEtcText((prev) => {
                const newData = [...prev];
                newData[index] = "";
                return newData;
            });

            updateParentList(index, { user_id: value, relation: "" });

        }

        //[학부모] - 학생과의 관계 select 값 변경 이벤트
        const handleParentRelationChange = (relationType: number, index: number) => {

            const relationText = relationWithStudent.find(r => r.value === relationType)?.label || "";

            setIsRelationEtc((prev) => {
                const newData = [...prev];
                newData[index] = relationType === 7; // 직접 입력을 선택한 경우
                return newData;
            });

            setRelationEtcText((prev) => {
                const newData = [...prev];
                newData[index] = "";
                return newData;
            });

            updateParentList(index, { relation: relationText })

        };
        
        //[학부모] - 학생과의 관계 직접 입력 시 이벤트
        const handleParentRelationTextChange = (value: string, index: number) => {

            setRelationEtcText((prev) => {
                const newData = [...prev];
                newData[index] = value;
                return newData;
            });

            updateParentList(index, { relation: value });

        };

        // 학부모 추가
        const handleAddParent = () => {

            updateRequestStudent({
                parent_list: [
                    ...requestStudent.parent_list,
                    {
                        user_id: 0,
                        relation: "",
                    }
                ]
            });
        }

        //[긴급연락처] - 보호자명 변경 이벤트
        const handleGuardianNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            

            if (!value) {
                setIsGuardianRelationEtc(false);
                setGuardianRelationEtcText("");
                updateRequestStudent({ [name]: value, temp_guardian_relation: "" });
            }
            else {
                updateRequestStudent({ [name]: value }); // 상태 업데이트
            }
        };
        
        //[긴급연락처] - 연락처 변경 이벤트
        const handleGuardianPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value.replace(/\D/g, '');
            if(value.length <= 11)
                updateRequestStudent({ temp_guardian_phone: value }); // 상태 업데이트
            
        };

        //[긴급연락처] - 학생과의 관계 select 값 변경 이벤트
        const handleGuardianRelationChange = (relationType: number) => {

            const relationText = relationWithStudent.find(r => r.value === relationType)?.label || "";

            // 직접 선택을 선택한 경우
            setIsGuardianRelationEtc(relationType === 7);
            setGuardianRelationEtcText("");

            updateRequestStudent({ temp_guardian_relation: relationText });

        };

        //[긴급연락처] 학생과의 관계 직접 입력 시 이벤트
        const handleGuardianRelationEtcChange = (value: string) => {
            setGuardianRelationEtcText(value);

            updateRequestStudent({ temp_guardian_relation: value }); // 상태 업데이트
            
        };

        //클래스 선택 옵션 깊은 복사
        let classSelectOptionsCopy = JSON.parse(JSON.stringify(classSelectOption));
        if (user_role === ROLE_DIRECTOR) {
            if(classSelectOptionsCopy.length)
                classSelectOptionsCopy = classSelectOptionsCopy.filter((_: any, i: number) => i !== 0);
        }

        //학부모 선택 옵션 깊은 복사
        const parentSelectOptionsCopy = JSON.parse(JSON.stringify(parentSelectOptions));

        return (
            <>
                <InputWrapR $gap="0">
                    <RowContentLeftWrap>
                        <div className="file-wrap">
                            <ImageOneWrap onClick={handleImageFileClick}>
                                <img
                                    className="preview-image"
                                    srcSet={selectImageUrl ? selectImageUrl : DefaultProfileS}
                                    alt={`${requestStudent.name}_profile`}
                                />
                                <img className="carema-icon" src="/image/icon/camera-background.svg" alt="camera"/>
                                <input
                                    type="file"
                                    name="file"
                                    onChange={(e) => onImageChange(e)}
                                    accept=".jpg, .png, .jpeg"
                                    style={{display: "none"}}
                                    ref={imageInput}
                                    multiple
                                />
                            </ImageOneWrap>

                        </div>
                    </RowContentLeftWrap>
                    <FlexWrapC style={{ width: '75%' }}>
                        <InputWrapR $alignItems="center">
                            <InputWrapC>
                                <label className="required_value">학생 이름</label>
                                <input type="text" name="name" value={requestStudent.name} onChange={handleInputChange}
                                    placeholder="학생 이름 입력"/>
                            </InputWrapC>
                                
                            <InputWrapC>
                                <label>생년월일</label>
                                <input type="text" name="birth_date" value={requestStudent.birth_date} onChange={handleBirthDayChange}
                                    placeholder="생년월일 입력(숫자만 입력 YYYY-MM-DD )"/>
                            </InputWrapC>
                        </InputWrapR>

                        <InputWrapR>
                            <InputWrapC>
                                <label>반</label>
                                {user_role === ROLE_DIRECTOR ?
                                    <SelectOption optionData={classSelectOptionsCopy}
                                                defaultValue={requestStudent.class_id}
                                                onChange={(class_id: number) => { handleClassChangeSelect(class_id) }}
                                                placeholderText={(!classSelectOptionsCopy.length) ? '등록된 반이 없습니다. 반을 등록해주세요.' : '선택해주세요'}
                                                dontChange={classSelectOptionsCopy.length === 0}
                                    />
                                    :
                                    <SelectOption optionData={classSelectOptionsCopy}
                                                defaultValue={Number(classSelectOptionsCopy[0]?.value)}
                                                onChange={(class_id: number) => { handleClassChangeSelect(class_id) }}
                                                dontChange
                                    />
                                }
                            </InputWrapC>
                        </InputWrapR>
                        <MiddleContentWrap>
                            <p>학부모</p>
                            {requestStudent.parent_list.map((parent: StudentParentType, index: number) => (
                                <InputWrapC>
                                    <InputWrapR $justifyContent="center">
                                        <InputWrapC $justifyContent="center">
                                            <label>학부모 선택</label>
                                            <SelectOption optionData={parentSelectOptionsCopy}
                                                        defaultValue={parent.user_id || 0}
                                                        onChange={(user_id: number) => {
                                                            handleParentChangeSelect(user_id, index)
                                                        }}
                                                        searchable={true}
                                            />
                                        </InputWrapC>
                                        <InputWrapC $justifyContent="center">
                                            <label>관계</label>
                                            <SelectOption optionData={parentRelationSelectOptions}
                                                defaultValue={changeRelationWithStudentType(parent.relation) || 0}
                                                onChange={(type: number) => handleParentRelationChange(type, index)}
                                                placeholderText={(!parentRelationSelectOptions.length || parent.user_id === 0) ? '학부모를 먼저 선택해주세요.' : '선택해주세요'}
                                                dontChange={parent.user_id === 0}
                                            />
                                        </InputWrapC>
                                    </InputWrapR>
                                    {isRelationEtc[index] &&
                                        <InputWrapR $justifyContent="flex-end">
                                            <input type="text" value={relationEtcText[index]} onChange={(e) => handleParentRelationTextChange(e.target.value, index)} placeholder="직접 입력해주세요." style={{width: 'calc(50% - 0.25rem)'}}/>
                                        </InputWrapR>
                                    }
                                </InputWrapC>
                            ))}
                            {requestStudent.parent_list.length < 2 &&
                                <OutlinePrimaryBtn onClick={handleAddParent}><img src={PlusIcon} alt="plus" />학부모 추가</OutlinePrimaryBtn>
                            }
                        </MiddleContentWrap>
                        <MiddleContentWrap>
                            <p>긴급 연락처</p>
                            <InputWrapC>
                                <InputWrapR $alignItems="center">
                                    <InputWrapC>
                                        <label>보호자 성함</label>
                                        <input type="text" name="temp_guardian_name" value={requestStudent.temp_guardian_name} placeholder="보호자 성함 입력" onChange={handleGuardianNameChange}/>
                                    </InputWrapC>
                                    <InputWrapC $justifyContent="space-between">
                                        <label>관계</label>
                                        <SelectOption optionData={guardianRelationSelectOptions}
                                            defaultValue={
                                                requestStudent.temp_guardian_relation ? changeRelationWithStudentType(requestStudent.temp_guardian_relation) : 0}
                                            onChange={(type: number) => handleGuardianRelationChange(type)}
                                            placeholderText={!guardianRelationSelectOptions.length ? '보호자를 먼저 입력해주세요.' : '선택해주세요'}
                                            dontChange={!requestStudent.temp_guardian_name}
                                        />
                                    </InputWrapC>
                                </InputWrapR>
                                {isGuardianRelationEtc &&
                                    <InputWrapR $justifyContent="flex-end">
                                        <input type="text" value={guardianRelationEtcText} onChange={(e) => handleGuardianRelationEtcChange(e.target.value)} placeholder="직접 입력해주세요." style={{width: 'calc(50% - 0.25rem)'}}/>
                                    </InputWrapR>
                                }
                            </InputWrapC>
                        </MiddleContentWrap>
                        <InputWrapR>
                            <InputWrapC>
                                <label>보호자 연락처</label>
                                <input type="text" name="temp_guardian_phone" value={requestStudent.temp_guardian_phone} onChange={handleGuardianPhoneChange}
                                    placeholder="보호자 연락처 입력('-'없이 숫자만 입력)"/>
                            </InputWrapC>
                        </InputWrapR>
                    </FlexWrapC>
                </InputWrapR>
            </>
        )
    }

    const StudentModalButton = ():JSX.Element => {

        //학생 validation 체크
        const studentValidation = ():boolean => {

            if(!requestStudent.name){
                alert("학생 이름을 입력해주세요.");
                return false;
            }

            if(!checkName(requestStudent.name)){
                alert("정확한 이름을 입력해주세요.");
                return false;
            }

            // 생년월일을 작성했는데 YYYY-MM-DD가 아니거나 유효한 날짜가 아닌 경우
            if (requestStudent.birth_date) {
                if (requestStudent.birth_date.length !== 10) {
                    alert("생년월일을 정확히 입력해주세요.");
                    return false;
                }
                if (!isValidDate(requestStudent.birth_date)) {
                    alert("생년월일을 다시 입력해주세요.");
                    return false;
                }

                if (checkFutureDate(requestStudent.birth_date) !== 'P') {
                    alert("생년월일을 다시 입력해주세요.");
                    return false;
                }
                
            }

            //학부모를 선택 또는 기본값으로 들어있다면
            //[학부모추가]버튼을 parent_list 길이로 체크하기 때문에 신규등록/수정 시 빈배열([])로 있으면 두번 클릭해야하는 상황 발생으로
            //1.0.11 이후에는 기본값이 들어있음
            //user_id === 0이면 서버에서 에러 발생으로 기본값인 경우 제거해줘야함

            //하나만 입력된 값이 있는지 확인 및 추출
            const checkParentList = requestStudent.parent_list.filter((p: StudentParentType, index: number) => {
                // (!p.user_id && !p.relation) 기본값인 경우-학부모 입력 안함, (p.user_id && p.relation) 학부모 선택한 경우
                // (p.user_id && p.relation === "직접 입력") 관계를 직접 입력 안 한 경우
                return !((!p.user_id && !p.relation) || (p.user_id && p.relation))
                    || (p.user_id && p.relation === "직접 입력" && (relationEtcText[index] === "직접 입력" || relationEtcText[index] === ""));
            });
            

            //학부모 선택 및 관계를 하나만 선택한 경우
            if (checkParentList.length) {
                alert("학부모 및 학생과의 관계를 선택해주세요.");
                return false;
            }

            const { temp_guardian_name, temp_guardian_relation, temp_guardian_phone} = requestStudent;

            // 긴급 연락처를 하나라도 입력된 경우
            if (temp_guardian_name || temp_guardian_relation || temp_guardian_phone) {

                //긴급 보호자 이름을 입력했지만, 관계를 입력하지 않았을 경우
                if(!temp_guardian_name || !temp_guardian_relation || !temp_guardian_phone){
                    alert("긴급 보호자 내용을 모두 입력해주세요.");
                    return false;
                }

                // 보호자 연락처 유효성 검사
                if (!checkMobile(temp_guardian_phone)) {
                    alert("긴급 보호자 연락처를 정확히 입력해주세요.");
                    return false;
                }

                //관계 직접 입력 시
                if(temp_guardian_relation === "직접 입력" && !guardianRelationEtcText){
                    alert("긴급 보호자와의 관계를 입력해주세요.");
                    return false;
                }
            }
            

            return true;
        }

        //학생 정보 암호화
        const encryptStudent = (studentInfo:StudentRequestType):StudentRequestType => {
            const newRequestStudent:StudentRequestType = {
                ...studentInfo
            }

            if(studentInfo.name){
                newRequestStudent.name = aesCBCEncrypt(studentInfo.name);
            }

            if(studentInfo.temp_guardian_name){
                newRequestStudent.temp_guardian_name = aesCBCEncrypt(studentInfo.temp_guardian_name);
            }

            if(studentInfo.temp_guardian_phone){
                newRequestStudent.temp_guardian_phone = aesCBCEncrypt(studentInfo.temp_guardian_phone);
            }

            return newRequestStudent;
        }

        //학생 등록 API 호출
        const handleCreateStudent = async ():Promise<void> => {
            if(!studentValidation()){
                return;
            }
            try {
                // [학부모] 기본값이 있는 경우 제외
                const newParentList = requestStudent.parent_list.filter((p: StudentParentType) => p.user_id && p.relation);
                const newRequestStudent: StudentRequestType = { ...requestStudent, parent_list: newParentList };

                //학생 정보 암호화
                const encryptedStudent:StudentRequestType = encryptStudent(newRequestStudent);
                const res: SingleResult<StudentInfo> = await createStudentHandler(encryptedStudent);
                
                if (res.code === 200) {
                    alert("학생이 등록되었습니다.");
                    setModalProps({...modalProps, isOpen:false});
                    getClassList();
                }
            }
            catch (e){

            }
        }

        //학생 수정 API 호출
        const handleUpdateStudent = async ():Promise<void> => {
            if(!studentValidation()){
                return;
            }

            try {
                // [학부모] 기본값이 있는 경우 제외
                const newParentList = requestStudent.parent_list.filter((p: StudentParentType) => p.user_id && p.relation);
                const newRequestStudent: StudentRequestType = { ...requestStudent, parent_list: newParentList };

                //학생 정보 암호화
                const encryptedStudent:StudentRequestType = encryptStudent(newRequestStudent);
                const res:SingleResult<StudentInfo> = await updateStudentHandler(clickStudentId, encryptedStudent);

                if (res.code === 200) {
                    alert("학생이 수정되었습니다.");
                    setModalProps({ ...modalProps, isOpen: false });
                    getClassList();
                }
            }
            catch (e){
                console.error(e);
                alert("학생 수정에 실패했습니다.");
            }
        }

        //학생 삭제 API 호출
        const handleDeleteStudent = async ():Promise<void> => {
            if(!window.confirm("학생을 삭제 처리하시겠습니까?")){
                return;
            }
            if(!window.confirm("삭제 시 복구가 불가합니다. 그래도 삭제하시겠습니까?")){
                return;
            }

            try{
                const res:SingleResult<StudentInfo> = await removeStudentHandler(clickStudentId);

                if (res.code === 200) {
                    alert("학생이 삭제 처리되었습니다.");
                    setModalProps({ ...modalProps, isOpen: false });
                    getClassList();
                }
            }
            catch (e){
                console.error(e);
            }
        }

        return (
            <>
                {modalProps.type === "createStudent" ? 
                    <SolidPrimaryBtn onClick={handleCreateStudent}>
                        등록 완료
                    </SolidPrimaryBtn>
                    : 
                    <FlexWrapR>
                        <SolidRedBtn type="button" style={{width:"40%"}} onClick={handleDeleteStudent}>
                            삭제 처리
                        </SolidRedBtn>
                        <SolidPrimaryBtn onClick={handleUpdateStudent} style={{width:"100%"}}>
                            수정 완료
                        </SolidPrimaryBtn>
                    </FlexWrapR>
                }
            </>
        )
    }

    // 학생 일괄 삭제
    async function removeStudent(){
        try{
            if(studentCheckIdList.length === 0){
                alert("삭제할 학생을 선택해주세요.");
                return;
            }
            
            if (!window.confirm("선택한 학생을 삭제하시겠습니까?")) {
                return;
            }
            if (!window.confirm("삭제 시 복구가 불가합니다. 그래도 삭제하시겠습니까?")) {
                return;
            }

            const res:SingleResult<any> = await removeStudentAllHandler({student_id_list: studentCheckIdList});

            if(res.code === 200){
                alert("학생 삭제가 완료되었습니다.");
                getClassList();
            }
            else{
                alert(`학생 삭제 중 오류가 발생하였습니다. ${res.message}`);
            }
        }
        catch(e){
            console.error(e);
        }
        finally {
            // 초기화
            setStudentCheckIdList([]);
            getStudentList();
        }
    }

    //학부모 select box 옵션 가져오기
    const getParentList = async () => {

        try {
            
            const userQueryParams:UserQueryParams = {
                page: 1,
                size: 1000,
                site_id: selectSiteId,
                name:"",
                role:"",
                class_id:0,
                role_number: 0,
                student_name: "",
            }

            const res:ListResult<UserInfo> = await getUser(userQueryParams);
            if (res.code === 200) {
                
                //학부모만 필터링
                const parentList: UserInfo[] = res.data.filter((userInfo: UserInfo) => userInfo.role === ROLE_PARENT);
                setParentList(parentList);

                // 학부모 이름+핸드폰 번호로 설정
                const newParentList = parentList.map(p => {
                    const maskingPhone = maskedPhoneNumber(aesCBCDecrypt(p.phone));
                    return { name: aesCBCDecrypt(p.name), phone: maskingPhone, value: p.id };
                })
                setParentSelectOptions(formattedSelectOptionNamePhone(newParentList));

            }

            setLoading(false);

        }
        catch (e){
            console.error(e);
        }
    }

    //학생 목록 가져오기
    const getStudentList = async () => {

        try {

            if (user_role === ROLE_TEACHER && classId === 0) {
                setStudentList([]);
            }
            else {

                const res: ListResult<StudentInfo> = await getStudent(studentQueryParams);
                
                if (res.code === 200) {
                    const getStudentWithImageUrl: StudentInfo[] = await getStudentImageUrl(res.data);
                    setStudentList(getStudentWithImageUrl);
                }

            }
        }
        catch(e){
            console.error(e);
        }
    }

    /**
     * 담당 class 가져오기
     */
    const getClassList = async () => {
        try {
            
            // 담당반 클래스 아이디 리스트 업데이트
            const classQueryParams: ClassQueryParams = {
                name: "",
                user_id: user_role === ROLE_DIRECTOR ? 0 : user_id,
                response_format: "",
                page: 1,
                size: 99999999
            };
        
            const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);
        
            // 반 정보가 없는 경우
            if (classResult.code !== 200) {
                setClassList([]);
            }
            else {
                if (user_role === ROLE_TEACHER && classResult.data.length === 0) setClassList([]);
                
                const userClassList: ClassInfo[] = classResult.data;
                setClassList(userClassList);

                const option = userClassSelectOption(userClassList, user_role);
                setClassSelectOption(option);
        
                const _classId = user_role === ROLE_DIRECTOR ? 0 : userClassList.length ? userClassList[0].id : 0;
                setClassId(_classId);
                // 학생 목록 조회 파라미터에 class_id 적용
                setStudentQueryParams(prev => ({ ...prev, class_id: _classId }));
                // 엑셀 학생 일괄 등록 시 select_class_id 적용
                setExcelSelectClassId(_classId);
            }

        } catch (error) {
            console.error("api error ", error);
        }
    
    };

    // 학부모/반 조회
    useEffect(() => {
        getParentList();
        getClassList();
    }, []);

    // 담당 반에 따라 반 학생 조회
    useEffect(() => {
        if (user_role === ROLE_DIRECTOR || classList.length !== 0) {
            getStudentList();
        }
        setLoading(false);
    }, [classList]);

    return (
        loading ? <Loading /> : (
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">학생 관리</p>
                    {!(user_role === ROLE_TEACHER && classList.length === 0) && 
                        <div className="button-wrap">
                            <SolidPrimaryBtn
                                onClick={() => { openModal('createStudent'); initRequestStudent(); }}
                                disabled={(user_role === ROLE_TEACHER && classList.length === 0) ? true : false}
                            >
                                신규 등록
                            </SolidPrimaryBtn>

                            <NoLinePrimaryBtn
                                onClick={() => { initExcel(); openModal('excelCreateAllStudent') }}
                                disabled={(user_role === ROLE_TEACHER && classList.length === 0) ? true : false}
                            >
                                엑셀 파일로 일괄 등록
                            </NoLinePrimaryBtn>
                        </div>
                    }
                </PageHeaderTitleButtonStyle>
                <PageArticleWrap>
                    <nav className="filter-container">
                        <div className="filter-wrap">
                            <label>반</label>
                            {user_role === ROLE_DIRECTOR ?
                                <SelectOption optionData={classSelectOption}
                                            defaultValue={studentQueryParams.class_id}
                                            onChange={(class_id: number) => { handleClassSelectOptions(class_id) }} />
                                :
                                <SelectOption optionData={classSelectOption}
                                            defaultValue={Number(classSelectOption[0]?.value)}
                                            onChange={(class_id: number) => { handleClassSelectOptions(class_id) }}
                                            dontChange
                                            placeholderText={!classSelectOption.length ? "담당반 없음" : ""}
                                />
                            }
                        </div>
                        {/* <FilterWrap>
                            <label>학부모</label>
                            <SelectOption optionData={parentSelectOptions}
                                          defaultValue={studentQueryParams.user_id}
                                          onChange={(user_id:number) => {handleParentSelectOptions(user_id)}}/>
                        </FilterWrap> */}
                        <div className="filter-wrap">
                            <label>학생</label>
                            {!classList.length && user_role === ROLE_TEACHER ? 
                                <input placeholder="담당반을 먼저 지정해주세요" disabled style={{ height: 'auto' }} />
                                :
                                <input type="text"
                                    placeholder="학생 이름을 입력해주세요."
                                    onChange={(e) => { handleStudentNameSearch(e.target.value) }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') getStudentList();
                                }} />
                            }
                            {/* <SelectOption optionData={studentSelectOptions}
                                          defaultValue={studentQueryParams.user_id}
                                            onChange={(user_id: number) => { handleStudentSelectOptions(user_id) }}
                            /> */}
                        </div>
                        <SolidPrimarySubBtn onClick={getStudentList}>조회</SolidPrimarySubBtn>
                    </nav>

                    <article className="list-content-container">
                        <div className="article-header height-auto">
                            <p>
                                <span className="article-header-title">학생 목록({studentList.length})</span>
                            </p>
                            {!(user_role === ROLE_TEACHER && classList.length === 0) &&
                                <FlexWrapR $alignItems="center" $gap="1rem">
                                    <SolidRedBtn type="button" onClick={removeStudent} disabled={(user_role === ROLE_TEACHER && classList.length === 0) ? true : false}>
                                        일괄 삭제
                                    </SolidRedBtn>
                                </FlexWrapR>
                            }
                        </div>
                        {
                            (user_role === ROLE_TEACHER && classList.length === 0) ? // 선생님이면서 담당반이 없는 경우
                                <NoDataWrap><NoDataWithImageText text={NoTeamClassDataText} /></NoDataWrap>
                            : studentList.length === 0 ?
                                <NoDataWrap><NoDataWithImageText text={NoStudentDataText}/></NoDataWrap>
                            :(
                                <StudentListViewer studentList={studentList}
                                                parentList={parentList}
                                                allStudentCheck={allStudentCheck}
                                                studentCheckIdList={studentCheckIdList}
                                                setAllStudentCheck={setAllStudentCheck}
                                                handleAllStudentCheck={handleAllStudentCheck}
                                                handleStudentCheck={handleStudentCheck}
                                                changeRequestStudent={changeRequestStudent}
                                                openModal={openModal} />
                            )
                        }
                    </article>
                </PageArticleWrap>
                {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
                <DefaultModalComponent isOpen={modalProps.isOpen}
                                       content={modalProps.type !== "excelCreateAllStudent" ? StudentModalContent() : ExcelCreateAllStudentContent()}
                                       button={modalProps.type !== "excelCreateAllStudent" ? StudentModalButton() : ExcelModalButton()}
                                       type={modalProps.type}
                                       isClose={modalProps.isClose}
                                       title={modalProps.title} />
            </>
        )
    )
}

